export function formatPrice(
  value: string | number,
  currency: string | null | undefined = "TRY"
): string {
  const symbol = currency === "TRY" || !currency ? "₺" : currency;

  const num = typeof value === "number" ? value : Number(value);
  if (Number.isNaN(num)) {
    return `${value} ${symbol}`;
  }

  // Özel istek: başlangıç seed değerleri 0 ise "00.00 ₺" olarak göster
  if (num === 0) {
    return `00.00 ${symbol}`;
  }

  // Ondalık kısım sıfırsa gösterme (5000.00 → 5000, 5000.50 → 5000.50)
  const formatted = num % 1 === 0 
    ? num.toString() 
    : num.toFixed(2);
  return `${formatted} ${symbol}`;
}

export function formatPriceWithBottle(
  price: string | number,
  bottlePrice: string | number | null | undefined,
  currency: string | null | undefined = "TRY",
  lang: "tr" | "en" = "tr"
): string {
  const glassLabel = lang === "tr" ? "Bardak" : "Glass";
  const bottleLabel = lang === "tr" ? "Şişe" : "Bottle";
  const symbol = currency === "TRY" || !currency ? "₺" : currency;

  const glassPrice = formatPrice(price, currency);
  
  if (bottlePrice && Number(bottlePrice) > 0) {
    const bottlePriceFormatted = formatPrice(bottlePrice, currency);
    return `${glassLabel}: ${glassPrice} / ${bottleLabel}: ${bottlePriceFormatted}`;
  }

  return glassPrice;
}
